import { render, staticRenderFns } from "./AddOrderHistory.vue?vue&type=template&id=3711d4b0&scoped=true"
import script from "./AddOrderHistory.vue?vue&type=script&lang=js"
export * from "./AddOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./AddOrderHistory.vue?vue&type=style&index=0&id=3711d4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3711d4b0",
  null
  
)

export default component.exports